// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"217":"cd1201e56ef8003a77df","231":"dd5eb10460f35a2ae7ce","532":"1fa9f48771ba440eb827","691":"beb8b7c6dd083e1062de","774":"35639601c26be6618ae1"}[chunkId] + ".js";
};